import Autoconfianca from '../assets/Softs/autoconfianca.png'
import Empatia from '../assets/Softs/empatia.png'
import Etica from '../assets/Softs/etica.png'
import IntEmocional from '../assets/Softs/intEmocional.png'
import Resiliencia from '../assets/Softs/resiliencia.png'
import ResProblemas from '../assets/Softs/resProblemas.png'
import TrabEquipe from '../assets/Softs/trabEquipe.png'

export const softs = [
    {
        imagem1: Etica,
        nome: 'Ética',
    },
    {
        imagem1: Autoconfianca,
        nome: 'Autoconfiança',
    },
    {
        imagem1: IntEmocional,
        nome: 'Inteligência Emocional',
    },
    {
        imagem1: Resiliencia,
        nome: 'Resiliência',
    },
    {
        imagem1: ResProblemas,
        nome: 'Resolução de Problemas',
    },
    {
        imagem1: Empatia,
        nome: 'Empatia',
    },
    {
        imagem1: TrabEquipe,
        nome: 'Trabalho em Equipe',
    }
]
